import { format, parseISO } from 'date-fns';
import { HTMLInputTypeAttribute } from 'react';

import { GeneralConstants } from 'app/constants/general-constants';

/**
 * Our project operates exclusively on 'undefined' instead of 'null'
 *
 * However react uses undefined for input values to decide managed/unamanaged component.
 * Use these helper methods to convert the input values to a react safe type.
 */
export class InputValueUtils {
    public static optionalToBoolean(value: boolean | undefined): boolean {
        return !!value;
    }

    public static optionalToString(value: number | string | undefined, type?: HTMLInputTypeAttribute): string {
        if (value === undefined) {
            return '';
        }

        if ('date' === type && !!value) {
            return format(parseISO(value as string), 'yyyy-MM-dd');
        }

        return `${value}`;
    }

    public static optionalObject<T>(value?: T): T | null {
        if (!value) {
            return GeneralConstants.COMPONENT_VALUE_NULL;
        }

        return value;
    }

    public static optionalOutput<T>(value: T | null): T | undefined {
        if (value === GeneralConstants.COMPONENT_VALUE_NULL) {
            return undefined;
        }

        return value;
    }
}
